import CloseIcon from '@mui/icons-material/Close';
import { Box, Grid, IconButton } from '@mui/material';
import React, { useState } from 'react';
import { FaPlay } from 'react-icons/fa';
import ReactPlayer from 'react-player';
import ControlPanel from './ControlPanel';
import MutePopper from './MutePopper';

const BrandingPreview = (props) =>
{
	const { branding, theme, handleClose : handleClosePreview } = props;
	const [ player, setPlayer ] = useState(false);
	const [ anchorEl, setAnchorEl ] = useState<HTMLDivElement | null>(null);
	const [ open, setOpen ] = useState(false);

	const handlePlayer = () =>
	{
		branding?.introVideo && setPlayer(true);
	};

	const handleNavigate = () =>
	{
		handleClosePreview();
	};

	const handlePause = () =>
	{
		setPlayer(false);
	};

	const handlePlay = () =>
	{
		setPlayer(true);
	};

	const handleEnded = () =>
	{
		setPlayer(false);
	};

	const handleClick = (event: React.MouseEvent<HTMLDivElement>) =>
	{
		setAnchorEl(event.currentTarget);
		setOpen((prev) => !prev);
	};

	const handleClose = () =>
	{
		setOpen(false);
	};

	return (
		<Grid
			container
			sx={{
				backgroundRepeat : 'no-repeat',
				backgroundSize   : 'cover',
				height           : '100vh',
				width            : 'var(--percent100)',
				backgroundColor  : theme?.primaryColor ?? '#043040',
				display          : 'flex',
				flexDirection    : 'column',
				backgroundImage  : `url("${branding?.background?.url}")`
			}}
		>
			{/* Header */}
			<Grid container alignItems='center' px='var(--pixel12)' height={64}>
				<Grid item xs={6} display='flex' justifyContent='flex-start'>
					<Box
						component='img'
						src={`${branding?.logo?.url ?? 'http://localhost:3000/images/logos/inLynk_Logo.svg'}`}
						alt='inlynk logo'
						sx={{
							height : 'var(--pixel40)',
							width  : 'initial'
						}}
					/>
				</Grid>
				<Grid item xs display='flex' justifyContent='flex-end'>
					<IconButton onClick={handleNavigate} sx={{ background: 'rgba(0,0,0,0.22)', width: 28, height: 28, borderRadius: 'var(--percent50)' }}>
						<CloseIcon sx={{ color: 'white' }} />
					</IconButton>
				</Grid>
			</Grid>

			{/* Video Player */}
			<Grid
				container
				sx={{
					display        : 'flex',
					justifyContent : 'center',
					alignItems     : 'center',
					flexGrow       : 1
				}}
			>
				<Grid
					item
					xs={12}
					sm={10}
					md={9}
					sx={{
						display        : 'flex',
						justifyContent : 'center',
						alignItems     : 'center',
						position       : 'relative',
						aspectRatio    : '16/9',
						padding        : 'var(--pixel16)',
						borderRadius   : 'var(--pixel8)',
						overflow       : 'hidden',
						width          : 'var(--percent100)',
						maxHeight      : 'calc(100vh - 128px)', // Max height considering header and footer
						maxWidth       : 'var(--percent100)',
						height         : 'auto'
					}}
					onClick={handleClick}
				>
					{!player
						? (
							<>
								<Box
									component='img'
									src='/images/VideoImg.svg'
									sx={{
										width        : 'var(--percent100)',
										height       : 'var(--percent100)',
										objectFit    : 'cover',
										borderRadius : 'var(--pixel8)'
									}}
								/>
								<Box
									sx={{
										display         : 'flex',
										backgroundColor : '#55DDFF',
										alignItems      : 'center',
										justifyContent  : 'center',
										height          : 'var(--pixel40)',
										width           : 'var(--pixel40)',
										position        : 'absolute',
										top             : 'var(--percent50)',
										left            : 'var(--percent50)',
										transform       : 'translate(-50%, -50%)',
										borderRadius    : '5px',
										cursor          : 'pointer',
										zIndex          : 2
									}}
									onClick={handlePlayer}
								>
									<FaPlay style={{ color: 'var(--primaryColor)' }} />
								</Box>
							</>
						)
						: (
							<ReactPlayer
								url={branding?.introVideo?.url}
								controls
								width='var(--percent100)'
								height='var(--percent100)'
								playing
								onPlay={handlePlay}
								onPause={handlePause}
								onEnded={handleEnded}
								style={{ borderRadius: 'var(--pixel8)', objectFit: 'cover', overflow: 'hidden' }}
							/>
						)}
				</Grid>
			</Grid>
			{/* Footer */}
			<ControlPanel secondaryColor={theme?.secondaryColor} />
			{/* Popper */}
			{open && <MutePopper open={open} handleClose={handleClose} anchorEl={anchorEl}/>}
		</Grid>
	);
};

export default BrandingPreview;
